import { useLocation } from 'react-router-dom';
import type { LocationState } from '@/types';

export const useLocationFrom = (): string => {
    const { state } = useLocation();
    return (state as LocationState | null)?.from ?? '';
};
